import React from "react";

export default function CircularProgress({
  value = 0,
  size = 96,
  stroke = 8,
  color = "#22D3EE",
  trackColor = "rgba(255,255,255,0.08)",
  label,
  sublabel,
}) {
  const radius = (size - stroke) / 2;
  const c = 2 * Math.PI * radius;
  const v = Math.max(0, Math.min(100, value));
  const dash = (v / 100) * c;
  return (
    <div className="relative flex items-center justify-center" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <defs>
          <linearGradient id={`cp-grad-${size}`} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor={color} stopOpacity="1" />
            <stop offset="100%" stopColor={color} stopOpacity="0.55" />
          </linearGradient>
        </defs>
        <circle cx={size / 2} cy={size / 2} r={radius} stroke={trackColor} strokeWidth={stroke} fill="none" />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={`url(#cp-grad-${size})`}
          strokeWidth={stroke}
          fill="none"
          strokeLinecap="round"
          strokeDasharray={`${dash} ${c}`}
          style={{ transition: "stroke-dasharray 800ms ease-out", filter: `drop-shadow(0 0 6px ${color}99)` }}
        />
      </svg>
      <div className="absolute text-center">
        <div className="font-display text-xl font-medium text-white leading-none">{label ?? `${Math.round(v)}%`}</div>
        {sublabel && <div className="text-[10px] font-mono uppercase tracking-[0.18em] text-[#7C8FA8] mt-1">{sublabel}</div>}
      </div>
    </div>
  );
}
